import { vacationConstants } from '../constants'

const initialState = {
    list: null,
    error: null,
    loading: false,
    ajaxSpinner: false,
    ajaxStatus: null
}

export default function vacations(state = initialState, action) {
    switch (action.type) {
        case vacationConstants.LOADING_VACATION:
            return { ...state, loading: true, error: null }
        case vacationConstants.LOADING_VACATION_ERROR:
            return { ...state, loading: false, error: action.payload }
        case vacationConstants.UPDATE_VACATION:
            return {
                ...state,
                list:
                    state.list === null
                        ? [action.payload]
                        : state.list.findIndex((x) => x.id === action.payload.id) === -1
                            ? state.list.concat(action.payload)
                            : state.list.map((item) => {
                                return item.id === action.payload.id ? action.payload : item
                            }),
                loading: false
            }
        case vacationConstants.REMOVE_VACATION:
            return {
                ...state,
                list: state.list.filter((item) => {
                    return item.id !== action.payload.id
                }),
                loading: false
            }
        case vacationConstants.VACATION_AJAX_CALL:
            return { ...state, ajaxSpinner: true, ajaxStatus: null }
        case vacationConstants.VACATION_AJAX_SUCCESS:
            return { ...state, ajaxSpinner: false, ajaxStatus: null }
        case vacationConstants.VACATION_AJAX_FAILURE:
            return { ...state, ajaxSpinner: false, ajaxStatus: action.payload }
        case vacationConstants.VACATION_RESET:
            return { ...state, list: null }
        default:
            return state
    }
}
